import React from 'react';
import {
  Box,
  Stack,
  Typography
} from '@mui/material';

import { useClientZS } from '../../pages/ClientZS';

import { AgreementsCard } from './documents/AgreementsCard';
import { InvoicesCard } from './documents/InvoicesCard';

export const DocumentsDetails = () => {
  const { orderData } = useClientZS();

  if (!orderData) {
    return (
      <Typography
        variant="h5"
        textAlign="center"
      >
        Brak dokumentów
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        width: '100%'
      }}
    >
      <Stack spacing={4}>
        <AgreementsCard
          orderData={orderData}
        />

        <InvoicesCard
          orderData={orderData}
        />
      </Stack>
    </Box>
  );
};
